import { useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';

export function useValidator() {
  return useRef(new SimpleReactValidator()).current;
}
